<div class="controls-bottom">
    <div
        (click)="dialogRef.close()"
        class="fab big"
        id="btn-AddImage"
        matTooltip="Aanpassingen annuleren"
        matTooltipPosition="before">
        <i class="fas fa-undo"></i>
    </div>
    @if (showSave()) {
        <div (click)="save()" [class.disabled]="saving()" class="fab big primary" id="btn-Save" matTooltip="Opslaan" matTooltipPosition="before">
            @if (!saving()) {
                <i class="fas fa-check"></i>
            } @else {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </div>
    }
</div>
@if (editImage()) {
    <app-draw-on-image
        #draw
        [height]="height()"
        [image]="editImage()"
        [width]="width()">
    </app-draw-on-image>
}
